module.exports = __webpack_public_path__ + "img/qrcode_hrjlq.05450200.jpg";